// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--2KSX7","email":"styles-module--email--3qbeu"};